// Phase 7a (D2): the sheet's three-sentence rule, kept dependency-free so the
// Worker's test suite can load it directly — see `../filmRank` for why the
// app's own extensionless imports make that the exception rather than the
// rule. Mirrors `capText`/`sentences` in `src/harvest/normalise/exhibition.ts`
// on the Worker side; duplicated rather than shared across the two build
// systems, with a test on each side.

function collapse(text: string): string {
  return text
    .replace(/<[^>]*>/g, ' ')
    .replace(new RegExp('[\\s\\u00a0\\u2028\\u2029]+', 'g'), ' ')
    .trim()
}

function stopAt(s: string, i: number): boolean {
  if (!'.!?'.includes(s[i])) return false
  return i === s.length - 1 || /\s/.test(s[i + 1])
}

/** The whole of a text, capped rather than cut mid-clause. */
export function capText(text: string, max = 2000): string {
  const s = collapse(text)
  if (s.length <= max) return s
  const cut = s.slice(0, max)
  for (let i = cut.length - 1; i >= 0; i--) {
    if (stopAt(cut, i)) return cut.slice(0, i + 1).trim()
  }
  return cut.trim()
}

/** The first `n` sentences of `text`, capped at `max` characters — the
 *  sheet's own rule, D2: up to three sentences of an exhibition's text. */
export function sentences(text: string, n: number, max = 400): string {
  const s = collapse(text)
  const out: string[] = []
  let start = 0
  for (let i = 0; i < s.length && out.length < n; i++) {
    if (stopAt(s, i)) {
      out.push(s.slice(start, i + 1).trim())
      start = i + 1
    }
  }
  const joined = out.length ? out.join(' ') : s
  return capText(joined, max)
}
